import React from 'react'
import moment from 'moment-timezone'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'

const useStyles = makeStyles((theme: Theme) => ({
  verticalLine: {
    height: '20px',
    margin: '2px auto'
  }
}))

const DatePeriodFragment: React.FC<{
  startTime: string
  endTime: string
  removeTime?: boolean
}> = ({ startTime, endTime, removeTime = false }) => {
  const classes = useStyles({})
  return (
    <React.Fragment>
      <Box display="flex" flexDirection="column" alignItems="center" my={1}>
        {removeTime ? (
          <React.Fragment>
            <Typography variant="body2">
              {startTime ? moment(startTime).format('YYYY/MM/DD') : '指定なし'}
            </Typography>
            <div className={classes.verticalLine}>
              <ExpandMore />
            </div>
            <Typography variant="body2">
              {endTime ? moment(endTime).format('YYYY/MM/DD') : '指定なし'}
            </Typography>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Typography variant="body2">
              {startTime ? moment(startTime).format('YYYY/MM/DD HH:mm') : '指定なし'}
            </Typography>
            <div className={classes.verticalLine}>
              <ExpandMore />
            </div>
            <Typography variant="body2">
              {endTime ? moment(endTime).format('YYYY/MM/DD HH:mm') : '指定なし'}
            </Typography>
          </React.Fragment>
        )}
      </Box>
    </React.Fragment>
  )
}

export default DatePeriodFragment
